// import React from "react";
// import {
//   Wallet,
//   HeartPulse,
//   Plane,
//   BookOpen,
//   Home,
//   Laptop,
//   Users,
//   Baby,
//   Calendar,
//   TrendingUp,
//   Coffee,
//   Dumbbell,
// } from "lucide-react";

// const perks = [
//   { icon: Wallet, title: "Competitive Salary", desc: "Top-of-market compensation with equity options" },
//   { icon: HeartPulse, title: "Health & Wellness", desc: "Premium healthcare, dental, and vision coverage" },
//   { icon: Plane, title: "Unlimited PTO", desc: "Take the time you need to recharge and explore" },
//   { icon: BookOpen, title: "Learning Budget", desc: "$3,000 annual stipend for courses and conferences" },
//   { icon: Home, title: "Remote First", desc: "Work from anywhere in the world" },
//   { icon: Laptop, title: "Latest Equipment", desc: "Top-tier laptop and accessories of your choice" },
//   { icon: Users, title: "Team Offsites", desc: "Quarterly in-person gatherings in amazing locations" },
//   { icon: Baby, title: "Parental Leave", desc: "16 weeks fully paid leave for all parents" },
//   { icon: Calendar, title: "Flexible Schedule", desc: "Work when you're most productive" },
//   { icon: TrendingUp, title: "Career Growth", desc: "Clear paths for advancement and mentorship" },
//   { icon: Coffee, title: "Coffee & Snacks", desc: "Fully stocked kitchen in all offices" },
//   { icon: Dumbbell, title: "Gym Membership", desc: "Subsidized fitness and wellness programs" },
// ];

// export default function PerksBenefits() {
//   return (
//     <div className="w-full py-20 px-4 lg:px-16 bg-gradient-to-b from-white to-blue-50/20">
//       <div className="text-center space-y-6 mb-12">
//         <span className="text-blue-500 font-semibold tracking-wide text-sm px-4 py-1 rounded-full border border-blue-200">
//           PERKS & BENEFITS
//         </span>
//         <h2 className="text-4xl md:text-5xl font-bold ">Designed for Your Success</h2>
//         <p className="text-gray-600 max-w-xl mx-auto">
//           We invest in our team with comprehensive benefits that support your professional and personal growth.
//         </p>
//       </div>

//       <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
//         {perks.map(({ icon: Icon, title, desc }, index) => (
//           <div
//             key={index}
//             className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition-all"
//           >
//             <div className="bg-gradient-to-br from-[#2A9CD7] to-[#093A5B] text-white w-12 h-12 flex items-center justify-center rounded-xl mb-4">
//               <Icon size={22} />
//             </div>
//             <h3 className="text-lg font-semibold">{title}</h3>
//             <p className="text-gray-600 text-sm mt-1">{desc}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }
// If you're on Next.js App Router, keep this at the very top:
// "use client";

import React, { useEffect, useRef, useState } from "react";
import {
  Wallet,
  HeartPulse,
  Plane,
  BookOpen,
  Home,
  Laptop,
  Users,
  Baby,
  Calendar,
  TrendingUp,
  Coffee,
  Dumbbell,
  DollarSign,
  Pizza,
  Sparkles,
} from "lucide-react";

const perks = [
  {
    icon: DollarSign,
    title: "Competitive Salary",
    desc: "Top-of-market compensation with equity options",
  },
  {
    icon: HeartPulse,
    title: "Health & Wellness",
    desc: "Premium healthcare, dental, and vision coverage",
  },
  {
    icon: Plane,
    title: "Unlimited PTO",
    desc: "Take the time you need to recharge and explore",
  },
  // { icon: BookOpen, title: "Learning Budget", desc: "$3,000 annual stipend for courses and conferences" },
  {
    icon: Home,
    title: "Remote First",
    desc: "Work from anywhere in the world",
  },
  {
    icon: Laptop,
    title: "Latest Equipment",
    desc: "Top-tier laptop and accessories of your choice",
  },
  {
    icon: Pizza,
    title: "Team Offsites",
    desc: "Quarterly in-person gatherings in amazing locations",
  },
  // { icon: Users, title: "Parental Leave", desc: "16 weeks fully paid leave for all parents" },
  {
    icon: Calendar,
    title: "Flexible Schedule",
    desc: "Work when you're most productive",
  },
  {
    icon: Sparkles,
    title: "Career Growth",
    desc: "Clear paths for advancement and mentorship",
  },
  // { icon: Coffee, title: "Coffee & Snacks", desc: "Fully stocked kitchen in all offices" },
  // { icon: Dumbbell, title: "Gym Membership", desc: "Subsidized fitness and wellness programs" },
];

const stats = [
  { label: "Glassdoor Rating", value: 4.9, suffix: "/5", decimals: 1 },
  { label: "Employee Satisfaction", value: 95, suffix: "%", decimals: 0 },
  { label: "Countries Represented", value: 50, suffix: "+", decimals: 0 },
];

// CountUp now takes a "start" trigger
function CountUp({ start, end, duration = 1500, decimals = 0 }) {
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!start) return; // wait until visible

    let frame = 0;
    const frameDuration = 1000 / 60;
    const totalFrames = Math.round(duration / frameDuration);

    const counter = setInterval(() => {
      frame++;
      const progress = frame / totalFrames;
      const current = end * progress;
      setValue(current);

      if (frame >= totalFrames) {
        clearInterval(counter);
        setValue(end);
      }
    }, frameDuration);

    return () => clearInterval(counter);
  }, [start, end, duration]);

  return <span>{value.toFixed(decimals)}</span>;
}

export default function PerksBenefits() {
  const statsRef = useRef(null);
  const [startCount, setStartCount] = useState(false);

  // IntersectionObserver for scroll detection
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setStartCount(true);
          observer.disconnect(); // prevent retrigger
        }
      },
      {
        threshold: 0.4, // 40% visible before triggering
      },
    );

    if (statsRef.current) observer.observe(statsRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <div className="w-full py-20 px-4 lg:px-16 bg-gradient-to-b from-white to-blue-50/20">
      <div className="text-center space-y-6 mb-12">
        {/* text-[#2A9CD7] font-semibold tracking-wider text-sm px-4 py-2 rounded-full border border-blue-200 */}
        <span className="carrers_perks-class">PERKS & BENEFITS</span>
        <h2 className="carrers_perks-heading">Designed for Your Success</h2>
        <p className="carrers_perks-para">
          We invest in our team with comprehensive benefits that support your
          professional and personal growth.
        </p>
      </div>

      {/* Perks */}
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
        {perks.map(({ icon: Icon, title, desc }, index) => (
          <div
            key={index}
            className="bg-white p-6 rounded-xl shadow-sm border border-gray-200 hover:shadow-md transition-all"
          >
            <div className="bg-gradient-to-br from-[#2A9CD7] to-[#093A5B] text-white w-12 h-12 flex items-center justify-center rounded-xl mb-4">
              <Icon size={22} />
            </div>
            <h3 className="text-xl font-semibold text-[#093A5B]">{title}</h3>
            <p className="text-gray-600 text-sm mt-1">{desc}</p>
          </div>
        ))}
      </div>

      {/* Stats section with scroll-trigger */}
      <div ref={statsRef} className="max-w-6xl mx-auto mt-16">
        <div className="grid gap-6 md:grid-cols-3">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-3xl bg-gradient-to-r from-[#093A5B] to-[#2A9CD7] px-8 py-8 text-center text-white shadow-md"
            >
              <div className="text-4xl md:text-5xl font-semibold leading-none mb-3">
                <CountUp
                  start={startCount}
                  end={stat.value}
                  decimals={stat.decimals}
                />
                <span className="ml-1">{stat.suffix}</span>
              </div>
              <p className="text-sm md:text-base opacity-90">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
